import React from 'react';
import { CampaignTab } from '../../constants/common';
import { useAppSelector } from '../../store/store';
import { getCurrentlyWorkingSession } from '../../store/selector/session.selector';
import { SessionStage } from '../../interfaces/session.interface';

interface IProps {
    activeTab: CampaignTab;
    setActiveTab: React.Dispatch<React.SetStateAction<CampaignTab>>;
}

const CampaignTabs = ({ activeTab, setActiveTab }: IProps) => {
    const currentlyWorkingSession = useAppSelector(getCurrentlyWorkingSession);

    return (
        <div className="tw-w-full tw-px-6 tw-py-4 tw-border-b tw-border-gray-400">
            {currentlyWorkingSession && (
                <div className="tw-flex tw-items-center">
                    {/* Plan Tab */}
                    <div className="tw-flex tw-items-center">
                        <div
                            className={`tw-flex tw-items-center tw-gap-[6px] tw-py-[10px] tw-px-4 tw-rounded-l-md tw-font-semibold tw-cursor-pointer ${
                                activeTab === CampaignTab.PLAN
                                    ? 'tw-bg-purple-500'
                                    : 'tw-bg-gray-300'
                            }`}
                            onClick={() => setActiveTab(CampaignTab.PLAN)}
                        >
                            {currentlyWorkingSession.stage === SessionStage.PLAN ? (
                                <span
                                    className={`tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-font-bold tw-bg-white ${
                                        activeTab === CampaignTab.PLAN
                                            ? 'tw-text-purple-500'
                                            : 'tw-text-black'
                                    }`}
                                >
                                    1
                                </span>
                            ) : (
                                <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-font-bold tw-text-white">
                                    <i
                                        className={`ph-bold ph-check ${activeTab === CampaignTab.PLAN ? 'tw-text-white' : 'tw-text-black'}`}
                                    ></i>
                                </span>
                            )}
                            <span
                                className={`${activeTab === CampaignTab.PLAN ? 'tw-text-white' : 'tw-text-black'}`}
                            >
                                Plan
                            </span>
                        </div>

                        <div className="tw-w-3 tw-h-[2px] tw-bg-gray-400"></div>
                    </div>

                    {/* Create Tab */}
                    <div className="tw-flex tw-items-center">
                        <div
                            className={`tw-flex tw-items-center tw-gap-[6px] tw-py-[10px] tw-px-4 tw-font-semibold tw-cursor-pointer ${
                                activeTab === CampaignTab.CREATE
                                    ? 'tw-bg-purple-500'
                                    : 'tw-bg-gray-300'
                            }`}
                            onClick={() => setActiveTab(CampaignTab.CREATE)}
                        >
                            {currentlyWorkingSession.stage !== SessionStage.PUBLISH ? (
                                <span
                                    className={`tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-font-bold tw-bg-white ${
                                        activeTab === CampaignTab.CREATE
                                            ? 'tw-text-purple-500'
                                            : 'tw-text-black'
                                    }`}
                                >
                                    2
                                </span>
                            ) : (
                                <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-font-bold tw-text-white">
                                    <i
                                        className={`ph-bold ph-check ${activeTab === CampaignTab.CREATE ? 'tw-text-white' : 'tw-text-black'}`}
                                    ></i>
                                </span>
                            )}
                            <span
                                className={`${activeTab === CampaignTab.CREATE ? 'tw-text-white' : 'tw-text-black'}`}
                            >
                                Create
                            </span>
                        </div>

                        <div className="tw-w-3 tw-h-[2px] tw-bg-gray-400"></div>
                    </div>

                    {/* Publish Tab */}
                    <div className="tw-flex tw-items-center">
                        <div
                            className={`tw-flex tw-items-center tw-gap-[6px] tw-py-[10px] tw-px-4 tw-rounded-r-md tw-font-semibold tw-cursor-pointer ${
                                activeTab === CampaignTab.PUBLISH
                                    ? 'tw-bg-purple-500'
                                    : 'tw-bg-gray-300'
                            }`}
                            onClick={() => setActiveTab(CampaignTab.PUBLISH)}
                        >
                            <span
                                className={`tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-font-bold tw-bg-white ${
                                    activeTab === CampaignTab.PUBLISH
                                        ? 'tw-text-purple-500'
                                        : 'tw-text-black'
                                }`}
                            >
                                3
                            </span>
                            <span
                                className={`${activeTab === CampaignTab.PUBLISH ? 'tw-text-white' : 'tw-text-black'}`}
                            >
                                Publish
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CampaignTabs;
